import React, { useState } from "react";
import { Modal, Nav, Row, Col } from "react-bootstrap";
import {
  ClockHistory,
  CalendarCheck,
  Clock,
  CurrencyDollar,
  FileSpreadsheet,
  Percent, // NEW ICON
} from "react-bootstrap-icons";
import AttendanceView from "./AttendanceView";
import LeaveView from "./LeaveView";
import ShiftView from "./ShiftView";
import PayrollView from "./PayrollView";
import TaxRulesAdmin from "./TaxRulesAdmin";
import CommissionView from "./CommissionView"; // NEW COMPONENT

const EmployeeDetails = ({ show, onHide, employee }) => {
  const [activeTab, setActiveTab] = useState("attendance");

  return (
    <Modal show={show} onHide={onHide} fullscreen={true}>
      <Modal.Header closeButton>
        <Modal.Title>
          {employee?.first_name} {employee?.last_name} - Details
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={3} lg={2} className="border-end">
            <Nav variant="pills" className="flex-column">
              <Nav.Link
                active={activeTab === "attendance"}
                onClick={() => setActiveTab("attendance")}
              >
                <ClockHistory className="me-2" /> Attendance
              </Nav.Link>
              <Nav.Link
                active={activeTab === "leaves"}
                onClick={() => setActiveTab("leaves")}
              >
                <CalendarCheck className="me-2" /> Leave Management
              </Nav.Link>
              <Nav.Link
                active={activeTab === "shifts"}
                onClick={() => setActiveTab("shifts")}
              >
                <Clock className="me-2" /> Shift Management
              </Nav.Link>
              <Nav.Link
                active={activeTab === "payroll"}
                onClick={() => setActiveTab("payroll")}
              >
                <CurrencyDollar className="me-2" /> Payroll Management
              </Nav.Link>
              <Nav.Link
                active={activeTab === "tax-rules"}
                onClick={() => setActiveTab("tax-rules")}
              >
                <FileSpreadsheet className="me-2" /> Tax Rules
              </Nav.Link>

              {/* === COMMISSION TAB (ONLY IF commission_rate > 0) === */}
              {employee?.commission_rate > 0 && (
                <Nav.Link
                  active={activeTab === "commission"}
                  onClick={() => setActiveTab("commission")}
                >
                  <Percent className="me-2" /> Commission
                </Nav.Link>
              )}
            </Nav>
          </Col>
          <Col md={9} lg={10}>
            {activeTab === "attendance" && (
              <AttendanceView employeeId={employee?.id} />
            )}
            {activeTab === "leaves" && <LeaveView employeeId={employee?.id} />}
            {activeTab === "shifts" && <ShiftView employeeId={employee?.id} />}
            {activeTab === "payroll" && (
              <PayrollView employeeId={employee?.id} />
            )}
            {activeTab === "tax-rules" && <TaxRulesAdmin />}

            {/* === COMMISSION VIEW === */}
            {activeTab === "commission" && employee?.commission_rate > 0 && (
              <CommissionView employeeId={employee?.id} />
            )}
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default EmployeeDetails;